// Entry point for all JS

// So we can use jQuery plugins
// window.Vue = require('vue/dist/vue.js');

require('./global.js');
